import React from 'react'

const UIContext = React.createContext()

export default UIContext
